import React, { Fragment } from "react";
import { Calendar, momentLocalizer } from "react-big-calendar";
import moment from "moment";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import "react-big-calendar/lib/css/react-big-calendar.css";

import LoggedInNav from "../layout/IME/LoggedInNav";
import LoggedOutNav from "../layout/IME/LoggedOutNav";
import MinimumNav from "../layout/IME/MinimumNav";
import HomeFooter from "../layout/IME/HomeFooter";
import myEventsList from "../../utilities/calendarEvents";

const localizer = momentLocalizer(moment);

const imeCalendar = ({ auth: { user, isAuthenticated } }) => {
  return (
    <Fragment>
      {/* {isAuthenticated ? <LoggedInNav /> : <LoggedOutNav />} */}
      <MinimumNav />
      <div className="calendar-container">
        <Calendar
          localizer={localizer}
          events={myEventsList}
          startAccessor="start"
          endAccessor="end"
          style={{ height: "80vh" }}
          views={["month", "week", "day", "agenda"]}
        />
      </div>
      <div className="green bold center">Source: nationaldaycalendar.com</div>
      {/* <HomeFooter /> */}
    </Fragment>
  );
};

imeCalendar.propTypes = {
  auth: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
});

export default connect(mapStateToProps, {})(imeCalendar);
